import { TrustedDevicesClass } from './component/TrustedDevicesClass';
import globals from '@descope-ui/theme-globals';

export const vars = TrustedDevicesClass.cssVarList;

const TrustedDevices = {
  [vars.hostWidth]: 'auto',
  [vars.hostWidth]: '300px',
  [vars.hostMinWidth]: '300px',

  [vars.listBackgroundColor]: 'transparent',
  [vars.listBorderRadius]: '0',
  [vars.listBorderWidth]: '0',
  [vars.listPadding]: '0',
  [vars.listBoxShadow]: 'none',
  [vars.listItemsGap]: globals.spacing.lg,

  [vars.itemBorderColor]: globals.colors.surface.light,
  [vars.itemVerticalPadding]: globals.spacing.lg,
  [vars.itemHorizontalPadding]: globals.spacing.lg,
  [vars.itemBorderRadius]: globals.radius.xs,
  [vars.itemOutline]: 'transparent',
  [vars.itemBackgroundColor]: 'transparent',
  [vars.itemCursor]: 'default',
  [vars.itemContentGap]: globals.spacing.sm,

  [vars.badgeBorderColor]: globals.colors.surface.light,
  [vars.badgeTextColor]: globals.colors.surface.dark,
  [vars.badgeBorderRadius]: globals.radius.xs,
  [vars.badgeBackgroundColor]: globals.colors.surface.main,

  [vars.devicePanelGap]: globals.spacing.md,
  [vars.deviceIconGap]: globals.spacing.md,
  [vars.deviceIconSize]: '24px',
  [vars.lastLoginLabelGap]: globals.spacing.xs,

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default TrustedDevices;
